import React, { useState } from 'react'
import OperationWorkflowModal from 'common/components/OperationWorkflowModal'
import API from 'common/logic/API'
import { Button, Col, Form } from 'react-bootstrap'
import { Formik } from 'formik'
import Utils from "common/Utils"
import * as yup from 'yup'
import * as Types from 'common/utils/Types'
import { Navigate } from 'react-router-dom'

interface Props {
    onSuccess: string | ((result: unknown) => void)
    static?: boolean
    entryId: number
}

function AdjustFundWorkflow(props: Props) {

    const [redirect, setRedirect] = useState<string | null>(null)

    if (redirect) {
        return <Navigate to={redirect} replace />
    }

    const loadingStep = (_parameters: unknown) => {
        const dataToFetch: [Promise<any>] = [
            API.get(`/funds/${props.entryId}`).then(response => response.data)
        ]
        return Promise.all(dataToFetch)
            .then((arr) => ({
                entry: arr[0]
            }))
    }

    const userInputStep = (_parameters: unknown, loading_result: unknown, _values: unknown, _errors: unknown, completion: (input: unknown) => void) => {
        const lr = loading_result as any
        const formEl = form(lr.entry, completion)
        return { component: formEl, title: `Adjust fund ${lr.entry.name}` }
    }

    const executionStep = (_parameters: unknown, _loading_result: unknown, user_input: unknown) => {
        return API.post(`/funds/adjust/${props.entryId}`, user_input)
    }

    const completionCallback = (execution_result: unknown) => {
        if (Types.isString(props.onSuccess)) {
            setRedirect(props.onSuccess as string)
        } else {
            (props.onSuccess as (result: unknown) => void)(execution_result && (execution_result as any).data)
        }
    }

    function form(fund: any, completion: (input: unknown) => void) {

        const parseForm = (values: any) => {
            completion({
                reason: values.reason,
                date: values.date,
                newAmount: values.amount,
            })
        }

        const schema = yup.object().shape({
            reason: yup.string().required(),
            amount: yup.number().required(),
            date: yup.date().required(),
        })

        const today = Utils.formatDate(new Date())

        const initialValues = {
            date: today,
            reason: "Fund adjustment",
            amount: fund.amount,
        }

        return <>
            <Formik
                validationSchema={schema}
                onSubmit={parseForm}
                initialValues={initialValues}
            >
                {({
                    handleSubmit,
                    handleChange,
                    values,
                    errors,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>

                        <Form.Group controlId="formReason">
                            <Form.Label column sm="2">Reason</Form.Label>
                            <Form.Control
                                type='text'
                                name='reason'
                                placeholder="Reason"
                                value={values.reason}
                                onChange={handleChange}
                                isInvalid={!!errors.reason}
                            />
                            <Form.Control.Feedback type="invalid">{errors.reason}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Row>
                            <Form.Group as={Col} controlId="formAmount">
                                <Form.Label column sm="2">Amount</Form.Label>
                                <Form.Control
                                    type='text'
                                    name='amount'
                                    placeholder="-10.00"
                                    value={values.amount}
                                    onChange={handleChange}
                                    isInvalid={!!errors.amount}
                                />
                                <Form.Control.Feedback type="invalid">{errors.amount}</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formDate">
                                <Form.Label column sm="2">Date</Form.Label>
                                <Form.Control
                                    type='text'
                                    name='date'
                                    placeholder="2020-12-31"
                                    value={values.date}
                                    onChange={handleChange}
                                    isInvalid={!!errors.date}
                                />
                                <Form.Control.Feedback type="invalid">{errors.date}</Form.Control.Feedback>
                            </Form.Group>
                        </Form.Row>

                        <Button variant="primary" type="submit">Save</Button>

                    </Form>
                )}
            </Formik>
        </>
    }

    return <OperationWorkflowModal
        static={props.static}
        loadingStep={loadingStep}
        userInputStep={userInputStep}
        executionStep={executionStep}
        completionCallback={completionCallback}
    />
}

export default AdjustFundWorkflow
